export enum ShiftFilterType {
  CurrentAndNextShift = 1,
  TwentyFourHours,
  All
}
